import React from 'react';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {TListOfElement} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const OrderItem = Atom.createRender(
  ({attributes, classes, data, generateAttributes, renderChild}) => {
    const attributesWithListItem = attributes.set('role', 'listitem');

    return (
      <div {...generateAttributes(attributesWithListItem, classes)}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = createIntegratedAtom({
  displayName: 'Order Item',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Dynamo'), iconName('CollectionItem')),
  },
  showEmpty: true,
  constraints: {
    pinToParent: true,
    descendants: [
      {is: 'CommerceCheckoutOrderItemOptionList', rule: 'ExactlyOne'},
    ],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginBottom: px(20),
          display: 'flex',
        },
      },
    },
  },
  render: OrderItem,
  fields: {children: TListOfElement},
});

export default config;
